import './App.css'
import { SnackbarProvider } from 'notistack'
import { Home } from '../Home/Home'
import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setScreen } from '../../redux/modules/app'

export const App: FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const handler = () => {
      dispatch(
        setScreen({
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight,
        })
      )
    }

    // Set size at the first client-side load
    handler()

    window.addEventListener('resize', handler)

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SnackbarProvider maxSnack={5}>
      <Home />
    </SnackbarProvider>
  )
}

export default App
